import React, { useEffect, useState } from "react";
import "./home.css";
import "../analytics/analytics.css";
import "../analytics/overview/overview.css";
import { Skeleton, Tooltip, Typography, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { colorBrandObject } from "../../../constants/brandings";
import { readableColor } from "polished";

const HomeApi = ({
  type,
  selectedDropdownValue,
  transactionVolumeData,
  successfulPaymentData,
  totalPaymentData,
  loading,
  singleStartDate,
  startDate,
  endDate,
}) => {
  const [shouldHideComparison, setShouldHideComparison] = useState(null);

  useEffect(() => {
    if (selectedDropdownValue === "customDate") {
      if (!singleStartDate) {
        setShouldHideComparison(null);
      } else {
        setShouldHideComparison(singleStartDate);
      }
    } else {
      setShouldHideComparison(null);
    }
  }, [selectedDropdownValue, singleStartDate]);
  const cardSchema = {
    totalPayment: {
      backgroundColor: colorBrandObject?.firstKpiColor,
      percentage: totalPaymentData?.percent?.toFixed(2),
      successPercentage:
        Math.floor(totalPaymentData?.successPercent) ===
          totalPaymentData?.successPercent
          ? totalPaymentData?.successPercent.toString()
          : totalPaymentData?.successPercent?.toFixed(2),
      data: totalPaymentData,
      content:
        "Total number of new transactions initiated for a particular period.",
    },
    transactionVolumne: {
      backgroundColor: colorBrandObject?.firstKpiColor,
      percentage: transactionVolumeData?.percent?.toFixed(2),
      successPercentage:
        Math.floor(transactionVolumeData?.successPercent) ===
          transactionVolumeData?.successPercent
          ? transactionVolumeData?.successPercent.toString()
          : transactionVolumeData?.successPercent?.toFixed(2),
      data: transactionVolumeData,
      content:
        "Total value of successful transactions which includes uncaptured amounts as well for a particular period.",
    },
    successfulPayment: {
      backgroundColor: colorBrandObject?.firstKpiColor,
      percentage: successfulPaymentData?.percent?.toFixed(2),
      successPercentage:
        Math.floor(successfulPaymentData?.successPercent) ===
          successfulPaymentData?.successPercent
          ? successfulPaymentData?.successPercent.toString()
          : successfulPaymentData?.successPercent?.toFixed(2),
      data: successfulPaymentData,
      content:
        "Total number of all the approved sales transactions and authorized transactions for a particular period.",
    },
  };

  return (
    <div className="mainDivOfAnalytics w-100">
      <div className="displayDirectionRow w-100">
        <div className="w-100">
          {!cardSchema[type]?.data?.title || loading ? (
            <div className="w-100">
              <div
                className="contentStyling homeBorder"
                style={{
                  backgroundColor: cardSchema[type]?.backgroundColor,
                  width: "90%",
                  height: "114px",
                }}
              >
                <Skeleton variant="text" width={150} height={25} />
                <Skeleton variant="text" width={100} height={20} />
                <Skeleton variant="text" width={120} height={20} />
              </div>
            </div>
          ) : (
            <div
              className="contentStyling homeBorder iconSpacing"
              style={{ backgroundColor: cardSchema[type]?.backgroundColor }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography className="totalPaymentHeading labelSemiBold displayDirectionRow" style={{ color: readableColor(colorBrandObject?.firstKpiColor) }}>
                  {cardSchema[type]?.data?.title}
                </Typography>
                <Tooltip title={cardSchema[type].content}>
                  <IconButton
                    sx={{
                      "&:hover": { backgroundColor: "transparent" },
                    }}
                    disableFocusRipple
                    disableTouchRipple
                  >
                    <InfoOutlinedIcon
                      sx={{
                        color: "black",
                        width: "14px",
                        height: "14px",
                        order: 1,
                        marginLeft: "2px",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
              <Typography
                className="headerH2Bold amountHeading"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                  marginBottom: "4px",
                  color: readableColor(colorBrandObject?.firstKpiColor)
                }}
              >
                {cardSchema[type]?.data?.valueForLocale}
                {!shouldHideComparison &&
                  cardSchema[type]?.data?.percent !== undefined ? (
                  cardSchema[type]?.data?.percent !== 0 ? (
                    cardSchema[type]?.data?.percent > 0 ? (
                      <img
                        src="/assets/analytics/increase.svg"
                        alt="increase"
                        className="increaseLogo"
                      />
                    ) : (
                      <img
                        src="/assets/analytics/decrease.svg"
                        alt="decrease"
                        className="increaseLogo"
                      />
                    )
                  ) : (
                    <img
                      src="/assets/analytics/grip-lines.svg"
                      alt="same"
                      className="increaseLogo"
                    />
                  )
                ) : (
                  ""
                )}
              </Typography>
              {/* TODO:  Create generic function for  card Description */}
              {!shouldHideComparison &&
                cardSchema[type]?.data?.percent !== undefined && (
                  <Typography
                    className="labelRegular"
                    style={{ color: "#6c6c6c" }}
                  >
                    {cardSchema[type]?.data?.percent !== 0
                      ? Math.abs(cardSchema[type]?.percentage) + "%"
                      : ""}

                    {cardSchema[type]?.data?.previousData === false
                      ? " No data to compare "
                      : cardSchema[type]?.data?.percent > 0
                        ? " increase from "
                        : cardSchema[type]?.data?.percent < 0
                          ? " decrease from "
                          : " No change "}
                    {cardSchema[type]?.data?.percent !== 0 &&
                      selectedDropdownValue == "yesterday" &&
                      "previous day"}
                    {cardSchema[type]?.data?.percent !== 0 &&
                      selectedDropdownValue == "today" &&
                      "yesterday"}
                    {cardSchema[type]?.data?.percent !== 0 &&
                      (selectedDropdownValue === "thisWeek" ||
                        selectedDropdownValue === "lastWeek") &&
                      "last week"}
                    {cardSchema[type]?.data?.percent !== 0 &&
                      (selectedDropdownValue === "thisLastMonth" ||
                        selectedDropdownValue === "thisMonth") &&
                      "last month"}

                    {cardSchema[type]?.data?.percent !== 0 &&
                      selectedDropdownValue == "last3Months" &&
                      "last 3 months"}
                    {cardSchema[type]?.data?.percent !== 0 &&
                      selectedDropdownValue == "last6Months" &&
                      "last 6 months"}
                    {cardSchema[type]?.data?.percent !== 0 &&
                      selectedDropdownValue == "last12Months" &&
                      "last 12 months"}
                    {cardSchema[type]?.data?.percent !== 0 &&
                      selectedDropdownValue == "thisYear" &&
                      "last year"}
                  </Typography>
                )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeApi;
